/** @format */
export const DEFAULT_TEST_ID = 'insights-action';

/**
 * The tooltip's element id, which is what ties the button to the bubble it opens
 * for a screen reader. One action to a page, so a fixed id rather than a
 * generated one.
 */
export const TOOLTIP_ID = 'insights-action-tooltip';

/**
 * Reported when the product page's own insights action is pressed.
 *
 * The model page's hero has an action that does the same job — scroll down
 * to the insights sections — and reports `JOURNEY_ACTION_EVENT`. This is a
 * different surface: a reader can reach the product page without ever
 * seeing the model page's hero, and folding this click into that existing
 * number would make it impossible to tell the two apart after the fact. A
 * separate event name is what lets reporting filter one from the other.
 *
 * Named `KIT_INSIGHTS_*` — the shared prefix for both pages' entry-point
 * actions, since each opens both insights sections below it rather than
 * either one on its own — with `PRODUCT_PAGE` telling this apart from the
 * model page's `KIT_INSIGHTS_MODEL_PAGE_ACTION_CLICK`. Section-specific
 * events elsewhere in this experiment are named for their section instead
 * (`KIT_JOURNEY_*`, `KIT_INTELLIGENCE_*`).
 */
export const INSIGHTS_ACTION_EVENT = 'KIT_INSIGHTS_PRODUCT_PAGE_ACTION_CLICK';
